import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SignupParkingSession } from '@shared/models';
import { ActivatedRoute } from '@angular/router';
import { AlertService, runtimeAlerts } from '@shared/services';

@Component({
  selector: 'app-onboarding-finish-transfer',
  templateUrl: './onboarding-finish-transfer.component.html',
  styleUrl: './onboarding-finish-transfer.component.scss',
})
export class OnboardingFinishTransferComponent {
  @Input({ required: true }) parkingSession!: SignupParkingSession | null;

  @Output() completeProfileEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private route: ActivatedRoute,
    private alertService: AlertService,
  ) {}

  completeProfile() {
    if (this.parkingSession && !this.parkingSession.is_cleared) {
      this.alertService.add(runtimeAlerts['parkingSessionCouldNotBeTransferredAlert']);
    }

    this.completeProfileEvent.emit();
  }

  get hasPrice(): boolean {
    return !!this.parkingSession?.price && this.parkingSession.price.amount !== '0' && this.parkingSession.price.amount !== '0.00';
  }

  get canExitLocation(): boolean {
    return !!this.parkingSession?.is_cleared && !this.parkingSession?.exit_time;
  }

  get showPayOpenAmount(): boolean {
    return !this.parkingSession?.exit_time && !this.parkingSession?.is_cleared;
  }

  get showDontPayTicket(): boolean {
    return !this.parkingSession?.exit_time && !!this.parkingSession?.is_cleared;
  }
}
